import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const updateFreightLaneValidationSchema = Yup.object().shape({
  information: Yup.object().shape({
    carrier: Yup.mixed().nullable().required('Carrier is required'),
  }),
})

const createFreightLaneValidationSchema = Yup.object().shape({
  information: Yup.object().shape({
    carrier: Yup.mixed().nullable().required('Carrier is required'),
    city: Yup.mixed().nullable().required('City is required'),
    state: Yup.string().nullable().required('State is required'),
  }),
})

export const getFormOptions = isUpdate => ({
  resolver: yupResolver(isUpdate ? updateFreightLaneValidationSchema : createFreightLaneValidationSchema),
})

export default updateFreightLaneValidationSchema
